import { render, staticRenderFns } from "./MeuPerfil.vue?vue&type=template&id=5956ef50&"
import script from "./MeuPerfil.vue?vue&type=script&lang=js&"
export * from "./MeuPerfil.vue?vue&type=script&lang=js&"
import style0 from "./MeuPerfil.vue?vue&type=style&index=0&id=5956ef50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports